import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/skeuo.css";

import 'react-big-calendar/lib/css/react-big-calendar.css'

// Register the <lesson-walkthrough> web component app-wide (side-effect import)
import './lib/walkthrough/register'
import './lib/dashboard-overview/register'

// Suppress custom element re-registration warnings in development
if (import.meta.env.DEV) {
  const originalConsoleError = console.error;
  const originalConsoleLog = console.log;
  
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('custom element') && args[0].includes('already been defined')) {
      return; // Suppress TinyMCE/web component re-registration warnings
    }
    originalConsoleError.apply(console, args);
  };

  // Filter noisy debug logs in development
  console.log = (...args) => {
    const message = typeof args[0] === 'string' ? args[0] : '';
    
    // Suppress repetitive debug logs while keeping important app flow logs.
    if (
      message.includes('🎯 PROMPT_MODULE_PROPS:') ||
      message.includes('🔍 PROMPT_MODULE:') ||
      message.includes('PromptFields:') ||
      message.includes('🎯 CONTENT_AMPLIFIER_RENDER_CHECK:') ||
      message.includes('LearningModuleIntro:')
    ) {
      return; // Suppress noisy debug logs
    }
    
    originalConsoleLog.apply(console, args);
  };
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <App />
);
